import type { ReactNode } from "react"
import { Navigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { PORTAL_PROJECTS } from "@/app/router/portalRoutes"
import { useAuth } from "@/features/auth/AuthContext"
import {
  canAccessProjectPortalArea,
  type ProjectPortalPermissionArea,
} from "@/features/projects/projectNavPermissions"
import { LoadingBlock } from "@/widgets/LoadingBlock"

type RequireProjectsPolicyAccessProps = {
  area: ProjectPortalPermissionArea
  children: ReactNode
}

export const RequireProjectsPolicyAccess = ({ area, children }: RequireProjectsPolicyAccessProps) => {
  const { t } = useTranslation()
  const { grantedPolicies } = useAuth()

  if (grantedPolicies === null) {
    return <LoadingBlock variant="page" message={t("common.loading")} rootStyle={{ minHeight: "40vh" }} />
  }

  if (!canAccessProjectPortalArea(area, grantedPolicies)) {
    return <Navigate to={PORTAL_PROJECTS} replace />
  }

  return children
}
